import { getCorrespondenceList } from "redux/slices/getCorrespondenceListSlice";
import { getPaymentHistory } from "redux/slices/getPaymentHistorySlice";
import { getFinancials } from "service/policy/getFinancials";
import {
  getPrimaryOwnerFromParties,
  isAllowedToMakeCCPayment,
  isCalcfocusPolicy,
  isPolicyInGrace,
  isOldAlicUlPolicy,
  isPolicyInactiveByPolicyStatus,
} from "js/utilities";
import { useDispatch, useSelector } from "react-redux";
import { getImage } from "redux/slices/getImageSlice";
import { Link, useNavigate } from "react-router-dom";
import { useRef, useEffect, useState } from "react";
import { getTasks } from "service/policy/getTasks";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import {
  stringFormatingToPascal,
  getPolicyType,
  stringFormattingToCurrency,
  getName,
  getBadgeClassByPolicyStatus,
  getBadgeText,
  base64ToArrayBuffer,
  convertToTitleCase,
  getBillingTypeCodeMapping,
} from "js/formatting";

import getPaymentProfileApi from "service/paymentServices/GetPaymentProfile";
import Badge from "../General/Badge";
import PaymentDetailMultiGridTabs from "./PaymentDetailMultiGridTabs";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";
import config from "config/config";
import PDFDialog from "components/ModalDialogs/PDFDialog";
import * as fileSaver from "file-saver";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import Tooltip from "components/General/Tooltip";

export default function PaymentDetailCard({ data, idx }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  LoadingOverlay.propTypes = undefined;
  const { user } = useSelector((state) => state.user);
  const [primaryOwnerFullName, setPrimaryOwnerFullName] = useState();
  useEffect(() => {
    let primaryOwnerParty = getPrimaryOwnerFromParties(data?.parties);
    setPrimaryOwnerFullName(getName(primaryOwnerParty?.person));
  }, [user]);
  const [pdfDialogState, setPdfDialogState] = useState(false);
  const [paymentHistories, setPaymentHistories] = useState([]);
  const [paymentProfile, setPaymentProfile] = useState();
  const [statements, setStatements] = useState([]);
  const [filteredDocuments, setFilteredDocuments] = useState();
  const [loading, setLoading] = useState(false);
  const [pdfSource, setPdfSource] = useState("");
  const [desc, setDesc] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [lapsedOn, setLapsedOn] = useState();
  const [openPaymentTask, setOpenPaymentTask] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [party, setParty] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [showWarning, setShowWarning] = useState("");

  let statementList = [];

  let panelRef = useRef(null);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const UUID = uuidv4();
  useEffect(() => {
    // getTask APi call
    getTasks({
      contractId_array: [data?.contractID],
      agentId: "",
    }).then((response) => {
      const openTask = response.filter(
        (task) =>
          task.process === "MODE" &&
          task.status !== "C" &&
          task.status !== "E" &&
          (task.remark2.includes("MODE_CHANGE_FROM_PORTAL") ||
            task.remark3.includes("FREQUENCY") ||
            task.remark3.includes("AUTOPAY"))
      );
      setOpenPaymentTask(openTask);
      openTask?.find((task) => {
        if (task?.remark3 === "AUTOPAY") {
          setShowWarning(t("CustomerPaymentOverView-warning-message1"));
        } else if (task?.remark3 === "FREQUENCY") {
          setShowWarning(t("CustomerPaymentOverView-warning-message2"));
        }
      });
    });
    if (data?.billingTypeCode === "06") {
      // get Payment Profile i
      getPaymentProfileApi({
        policies: [data],
      })
        .then((response) => {
          if (response?.length > 0) {
            response?.forEach((profile) => {
              if (
                profile?.userId !== user?.userId &&
                profile?.paymentProfileId ===
                  data?.creditCard?.recurringReferenceId
              ) {
                setParty(profile);
                setShowTooltip(true);
              }
            });
            if (response[0]?.cardNumber) {
              setPaymentProfile(response);
            }
          }
        })
        .catch((error) => {
          console.error(
            "Server refused to connect, please try again later.",
            error
          );
        });
    }

    // get correspondense
    dispatch(
      getCorrespondenceList({
        policyId: [data?.contractID],
        agentId: "",
        beginDate: moment()
          .subtract(parseInt(config.PAYMENT_STATEMENT_DURATION), "year")
          .format("MM/DD/YYYY"),
        endDate: moment().format("MM/DD/YYYY"),
      })
    )
      .then((response) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          setFilteredDocuments(
            response.payload.allAlerts.filter(
              (x) =>
                x.document.typeOfDocument.toUpperCase() === "PREMNOT" ||
                x.document.typeOfDocument.toUpperCase() === "PREMNOT_OW1" ||
                x.document.typeOfDocument.toUpperCase() === "DIRECTBILL" ||
                x.document.typeOfDocument.toUpperCase() === "REMINDERNOTICE" ||
                x.document.typeOfDocument.toUpperCase() === "LAPSENOTICE"
            )
          );
        }
      })
      .catch((error) => {
        console.log("Error", error.message);
      });
    // get Payment History
    dispatch(
      getPaymentHistory([
        {
          contractId: data.contractID,
          policyNumber: data?.contractID,
        },
      ])
    )
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          setPaymentHistories(response.payload);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error", error.message);
      });
  }, [data]);

  useEffect(() => {
    if (filteredDocuments?.length > 0) {
      filteredDocuments?.map((document) => {
        statementList.push({
          statementName: `${document?.document?.typeOfDocument} - Policy# ${data?.oldPolicy}`,
          dateAdded: `${moment(document?.document?.dateOfDocument).format(
            "MM/DD/YYYY"
          )}`,
          type: `${document?.document?.typeOfDocument} - Contract# ${data?.oldPolicy}`,
          document: document,
        });
      });
      setStatements(statementList);
    }
    if (idx === 0) setPanelIsOpen(true);
  }, [idx, filteredDocuments]);

  async function getLapseOn(data) {
    setLoading(true);
    await getFinancials(data)
      .then((response) => {
        // Sort in descending order
        let cashValues = response.cashValues?.sort(
          (a, b) =>
            moment(b?.projectedlapseDate) - moment(a?.projectedlapseDate)
        );
        const lapseDate = cashValues[0]?.projectedlapseDate;
        setLapsedOn(lapseDate);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }

  const isPremiumDateNeedToDisplay = () => {
    return (
      !isOldAlicUlPolicy(data) ||
      data?.billingTypeCode === "02" ||
      data?.billingTypeCode === "06"
    );
  };

  const isAllowedToEditFrequency = data?.billingTypeCode === "02";

  return (
    <>
      <EverlakeLoadingOverlay
        isLoading={isLoading || loading}
        loadingText={t("CustomerPaymentOverView-loading-text")}
      >
        <div className="ui-card mt-4 xl:mt-6">
          <div className="flex flex-row items-start">
            <div className="px-4 pt-3 flex-grow xl:px-6 xl:pt-6">
              <h2 className="mb-0">
                <button
                  ref={panelRef}
                  className="flex items-center group"
                  aria-controls={UUID}
                  aria-expanded={panelIsOpen ? "true" : "false"}
                  aria-label={`Expand or collapse ${primaryOwnerFullName} Policy details`}
                  onClick={() => {
                    setPanelIsOpen((open) => (open = !open));
                  }}
                >
                  <span className="inline-block p-1 rounded-full mr-2 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                    <svg
                      className="ui-icon ui-plus w-4 h-4"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-plus"></use>
                    </svg>
                    <svg
                      className="ui-icon ui-minus w-4 h-4"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-minus"></use>
                    </svg>
                  </span>
                  <span className="text-lg font-body font-bold">
                    {data.policyType} {data ? `${getPolicyType(data)} - ` : ""}
                    {primaryOwnerFullName}
                  </span>
                </button>
              </h2>
            </div>

            <div className="px-4 pt-3 xl:px-6 xl:pt-6">
              {data?.status && data?.status !== "" && (
                <Badge
                  mediaSwitch={true}
                  status={getBadgeClassByPolicyStatus(data)}
                  statusText={getBadgeText(data)}
                  srPrefix="Policy"
                />
              )}
            </div>
          </div>

          <hr />
          {openPaymentTask.length > 0 && showWarning !== "" && (
            <div className="flex justify-items-center px-4 pb-4">
              <svg
                className="ui-icon w-4 h-4 mr-2 self-center text-ui-yellow"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-circle-solid-exclamation"></use>
              </svg>
              <p className="self-center text-ui-yellow font-semibold">
                {showWarning}
              </p>
            </div>
          )}

          <div
            id={UUID}
            className={`ui-payment-policy-card ${
              panelIsOpen ? "" : "ui-payment-policy-card-min"
            }`}
          >
            <div className="ui-payment-policy-details px-4 pb-4 xl:px-6 xl:pb-6">
              <div className="text-xs text-theme-text-tertiary">
                {t("CustomerPaymentOverView-policy-number")} {data.oldPolicy}
              </div>
              <div className="ui-payment-policy-details-grid">
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {isOldAlicUlPolicy(data)
                      ? t("CustomerPaymentOverView-planned-premium-amount")
                      : t("CustomerPaymentOverView-premium-amount")}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold sm:text-base md:text-xl">
                    {stringFormattingToCurrency(
                      data?.modalPremiumAmountTotal ?? 0
                    )}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {isOldAlicUlPolicy(data)
                      ? t("CustomerPaymentOverView-planned-payment-frequency")
                      : t("CustomerPaymentOverView-frequency")}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold">
                    {stringFormatingToPascal(data.billingMode)}{" "}
                    {isAllowedToEditFrequency &&
                      isAllowedToMakeCCPayment(data) &&
                      !isCalcfocusPolicy(data) && (
                        <span
                          title={`${
                            openPaymentTask.length > 0
                              ? t("CustomerPaymentOverView-warning-message3")
                              : ""
                          }`}
                        >
                          <button
                            className={`${"ui-btn-hyperlink font-semibold"}`}
                            disabled={openPaymentTask.length > 0}
                            onClick={() =>
                              navigate(
                                `/payment/edit-payment-frequency/${data.contractID}`
                              )
                            }
                          >
                            {t("CustomerPaymentOverView-edit")}
                          </button>
                        </span>
                      )}
                  </div>
                </div>
                {getBadgeText(data) === "Paid to date" && (
                  <div>
                    <div className="text-xs text-theme-text-tertiary">
                      {t("CustomerPaymentOverView-pending-payment-balance")}
                    </div>
                    <div className="text-sm text-theme-text-secondary font-semibold">
                      {data?.suspenseAmount}
                    </div>
                  </div>
                )}
                {isPremiumDateNeedToDisplay() && (
                  <div>
                    <div className="text-xs text-theme-text-tertiary">
                      {isOldAlicUlPolicy(data)
                        ? t("CustomerPaymentOverView-planned-premium-date")
                        : t("CustomerPaymentOverView-next-payment-due")}
                    </div>
                    <div className="text-sm  text-theme-text-secondary font-semibold sm:text-base md:text-xl">
                      {data.premiumDueDate
                        ? new Date(data.premiumDueDate).toLocaleDateString()
                        : ""}
                    </div>
                  </div>
                )}
                <div>
                  <div className="text-xs text-theme-text-tertiary flex items-center">
                    {t("CustomerPaymentOverView-autopay")}
                    {showTooltip && (
                      <Tooltip
                        xMargin="mx-0"
                        content={`Autopay was set up with ${convertToTitleCase(
                          party?.cardHolderName
                        )}'s credit card and won't appear in your payment methods.`}
                      />
                    )}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold">
                    {data?.billingTypeCode === "02" ||
                    data?.billingTypeCode === "06"
                      ? t("CustomerPaymentOverView-enrolled")
                      : t("CustomerPaymentOverView-not-enrolled")}
                    <div>
                      {data?.billingTypeCode === "06" &&
                        paymentProfile?.length > 0 &&
                        paymentProfile[0].cardNumber && (
                          <>
                            {t("CustomerPaymentOverView-credit-card")}
                            {paymentProfile[0].cardNumber}
                          </>
                        )}
                      {data?.billingTypeCode === "02" && (
                        <>
                          {t("CustomerPaymentOverView-bank-account")}
                          {data?.bankInfo?.bank?.accountNumber.substring(
                            data?.bankInfo?.bank?.accountNumber.length - 4
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("CustomerPaymentOverView-last-payment-received")}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold">
                    {data?.lastPaymentDate}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("CustomerPaymentOverView-payment-method")}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold">
                    {getBillingTypeCodeMapping(data?.billingTypeCode)}
                  </div>
                </div>
                {!isOldAlicUlPolicy(data) && (
                  <div>
                    {data?.status?.toLowerCase() === "lapsed" && (
                      <>
                        <div className="text-xs text-theme-text-tertiary">
                          {t("CustomerPaymentOverView-policy-lapsed-on")}
                        </div>
                        <div className="text-sm font-semibold text-theme-text-secondary">
                          <span className="text-ui-red">
                            {data?.statusDate}
                          </span>
                        </div>
                      </>
                    )}
                    {isPolicyInGrace(data) &&
                      data?.status?.toLowerCase() !== "extended term" && (
                        <>
                          <div className="text-xs text-theme-text-tertiary">
                            <button
                              className={`${
                                lapsedOn
                                  ? "text-xs text-theme-text-tertiary"
                                  : "ui-btn-hyperlink font-semibold"
                              }`}
                              onClick={() => {
                                if (!lapsedOn) getLapseOn(data);
                              }}
                            >
                              {t("CustomerPaymentOverView-lapse-date")}
                            </button>
                          </div>
                          <div className="text-sm font-semibold text-theme-text-secondary">
                            <span>{lapsedOn}</span>
                          </div>
                        </>
                      )}
                  </div>
                )}
              </div>
            </div>
            <PaymentDetailMultiGridTabs
              paymentHistory={paymentHistories}
              policyId={data?.contractID}
            />
            <EverlakeLoadingOverlay isLoading={isDownloading}>
              <div className="ui-payment-policy-statements p-4 xl:p-6">
                {/* Last statement button */}
                <div className="ui-download-document">
                  {filteredDocuments?.map((document, index) => {
                    if (
                      document?.document.typeOfDocument.toUpperCase() ===
                      "ANNSTMT"
                    ) {
                      return (
                        <div
                          // className="py-2 px-4 border border-ui-gray-light-medium rounded"
                          className="inline-block py-2 px-4 border border-ui-gray-light-medium rounded"
                          key={`document${index}`}
                        >
                          <div className="text-xs font-semibold text-theme-text-secondary">
                            {t("CustomerPaymentOverView-annual-statement")}
                          </div>
                          <div>
                            <button
                              className="ui-link-icon font-bold text-xs"
                              onClick={() => {
                                console.log(document);
                                if (document?.document?.name) {
                                  setIsDownloading(true);
                                  dispatch(
                                    getImage({
                                      imageFileName:
                                        document?.document?.name ?? "",
                                      policyId: document?.policy?.contractID,
                                    })
                                  )
                                    .then((response) => {
                                      setIsDownloading(false);
                                      let byteArray = base64ToArrayBuffer(
                                        response.payload.document.contentStream
                                          .type
                                      );
                                      let blob = new Blob([byteArray], {
                                        type: "application/pdf",
                                      });
                                      fileSaver.saveAs(
                                        blob,
                                        `${document?.document?.name}.pdf`
                                      );
                                    })
                                    .catch((error) => {
                                      console.log("Error", error.message);
                                      setPdfDialogState(true);
                                      setIsDownloading(false);
                                      setDesc(document?.document?.description);
                                      setPdfSource("");
                                    });
                                }
                              }}
                            >
                              <svg
                                className="ui-icon w-4 h-4"
                                focusable="false"
                                aria-hidden="true"
                                role="presentation"
                              >
                                <use href="#ui-icon-document-download"></use>
                              </svg>
                              {t("CustomerPaymentOverView-download-pdf")}
                            </button>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </EverlakeLoadingOverlay>
            <div className="ui-payment-policy-actions pt-4 pr-2 md:pr-6">
              <div className="text-right">
                {data?.billingTypeCode !== "02" &&
                data?.billingTypeCode !== "06" ? (
                  <>
                    {data?.billingTypeCode !== "08" &&
                      data?.billingTypeCode !== "09" &&
                      isAllowedToMakeCCPayment(data) &&
                      !isCalcfocusPolicy(data) && (
                        <span
                          className="pr-2"
                          title={`${
                            openPaymentTask.length > 0
                              ? t("CustomerPaymentOverView-warning-message3")
                              : ""
                          }`}
                        >
                          <button
                            className="ui-btn-secondary ui-btn-min-w"
                            disabled={
                              openPaymentTask.length > 0 ||
                              isPolicyInactiveByPolicyStatus(data.status)
                            }
                            onClick={() =>
                              navigate(
                                `/payment/manageautopay/${data.contractID}`
                              )
                            }
                          >
                            {t("CustomerPaymentOverView-set-up-autopay")}
                          </button>
                        </span>
                      )}

                    {isAllowedToMakeCCPayment(data, "onetimepayment") && (
                      <span
                        className="pr-2"
                        title={`${
                          openPaymentTask.length > 0
                            ? t("CustomerPaymentOverView-warning-message3")
                            : ""
                        }`}
                      >
                        <button
                          className="ui-btn-primary ui-btn-min-w pl-2"
                          disabled={
                            openPaymentTask.length > 0 ||
                            isPolicyInactiveByPolicyStatus(data.status)
                          }
                          onClick={() => navigate(`/payment/make-a-payment`)}
                        >
                          {t("CustomerPaymentOverView-make-a-payment")}
                        </button>
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    {isAllowedToMakeCCPayment(data, "onetimepayment") && (
                      <span
                        className="pr-2"
                        title={`${
                          openPaymentTask.length > 0
                            ? t("CustomerPaymentOverView-warning-message3")
                            : ""
                        }`}
                      >
                        <button
                          className="ui-btn-secondary ui-btn-min-w"
                          disabled={
                            openPaymentTask.length > 0 ||
                            isPolicyInactiveByPolicyStatus(data.status)
                          }
                          onClick={() => navigate(`/payment/make-a-payment`)}
                        >
                          {t("CustomerPaymentOverView-make-a-payment")}
                        </button>
                      </span>
                    )}
                    {!isCalcfocusPolicy(data) && !isOldAlicUlPolicy(data) && (
                      <span
                        className="pl-2"
                        title={`${
                          openPaymentTask.length > 0 ||
                          !isAllowedToMakeCCPayment(data)
                            ? t("CustomerPaymentOverView-warning-message3")
                            : ""
                        }`}
                      >
                        <button
                          className="ui-btn-primary ui-btn-min-w"
                          disabled={
                            openPaymentTask.length > 0 ||
                            !isAllowedToMakeCCPayment(data) ||
                            isPolicyInactiveByPolicyStatus(data.status)
                          }
                          onClick={() =>
                            navigate(
                              `/payment/manageautopay/${data.contractID}`
                            )
                          }
                        >
                          {t("CustomerPaymentOverView-manage-utopay")}
                        </button>
                      </span>
                    )}
                  </>
                )}
                <div className="mt-1 md:mt-2 pb-4">
                  <Link to={`/policies/${data.contractID}`} className="text-xs">
                    {t("CustomerPaymentOverView-view-policy-details")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {!isAllowedToMakeCCPayment(data, "onetimepayment") ? (
            <div className="text-center text-xs text-theme-text-secondary px-4 pb-6">
              {t("CustomerPaymentOverView-message")}
            </div>
          ) : (
            ""
          )}
        </div>
      </EverlakeLoadingOverlay>
      <PDFDialog
        title={`${data?.document?.document?.name ?? ""} Preview`}
        description={desc}
        pdfSource={pdfSource}
        dialogState={pdfDialogState}
        setDialogState={setPdfDialogState}
      />
    </>
  );
}
